module.exports = __webpack_public_path__ + "media/112.fde993b1.mp3";